// extracted by mini-css-extract-plugin
module.exports = {"title":"WhyTrustUs_title__Z_jLB","item":"WhyTrustUs_item__UFduk","advantages":"WhyTrustUs_advantages__W0rwX"};